module.exports = __webpack_public_path__ + "img/py.b7ba62d5.jpg";